import { authConfig } from '../../auth/authConfig';

const siteName = authConfig.SITE_NAME;
const relativePath = authConfig.RELATIVE_PATH

const fileDownload = async(siteId, path, filename, accessToken) => {
    try {
     const fileDownlod = `https://graph.microsoft.com/v1.0/sites/${siteId}/${path}/${filename}:/content`
      const response = await fetch(fileDownlod, {
        method: "GET",
        headers: {
            'Authorization': accessToken,
            'Content-Type': 'application/json'
        },
    })
    const arrayBuffer = await response.arrayBuffer();
    const byteArray = new Uint8Array(arrayBuffer);
    return byteArray
    } catch (error) {
      console.error(error);
    }
  }
  

export const getConsentFile = async(parentfolderpath, accessToken) => {
    try{
        const token = accessToken
        const getSiteIdurl = "https://graph.microsoft.com/v1.0/sites/" + siteName + ":/" + relativePath;
        //Get the site Id 
        const getsite = await fetch(getSiteIdurl, {
            method: "GET",
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            },
        })
        let siteResponse = await getsite.json()
        let siteID = siteResponse.id
        const getLibraryIdurl = "https://graph.microsoft.com/v1.0/sites/" + siteID + "/lists";
        //Get Library Id
        const getLibraryId = await fetch(getLibraryIdurl, {
            method: "GET",
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            },
        })
        let libraryResponse = await getLibraryId.json()
        let id = libraryResponse?.value?.filter((data) => data.displayName === "Documents")
        let get_id = id?.[0]?.id
        //drive_id
        const getLibraryIdurldrive = "https://graph.microsoft.com/v1.0/sites/" + siteID + "/drives";
        //Get Library Id
        const getLibrarydriveId = await fetch(getLibraryIdurldrive, {
            method: "GET",
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            },
        })
        let libraryResponseforDrive = await getLibrarydriveId.json()
        let finddriveid = libraryResponseforDrive?.value?.filter((data) => data.name === "Documents")
        let driveid = finddriveid?.[0]?.id
        const getsubfoldersitemsurl = "https://graph.microsoft.com/v1.0/sites/" + siteID + "/lists/" + get_id + "/items?$expand=fields";
        const folderitems = await fetch(getsubfoldersitemsurl, {
            method: "GET",
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            },
        })
        let folderitemsresp = await folderitems.json()
        let items = folderitemsresp?.value
        let file_name = items?.[0]?.fields?.FileLeafRef
        let file_link = items?.[0]?.webUrl  
        let path = `/drives/` + driveid + `/root:`
        let site_id = items?.[0]?.parentReference?.siteId
        const pdf = await fileDownload(site_id, path, file_name, accessToken)
        return pdf
    } catch (err) {
    }
}

// /drives/b!DcKbsL53q0OsAmEcT3nEGBOEhL0gfNNAgZUfAd1ahjvSTzU14I7ETJ3JffjrJjfD/root:/DummyPdf